<script>
import { SDK_CAPITALIZE_NAMES } from '../../utils/constant.js'

export default {
  name: 'PreCheckoutInfo',
  props: {
    preCheckoutData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      sdkCapitalizeNames: SDK_CAPITALIZE_NAMES
    }
  }
}
</script>

<template>
  <div id="preCheckout-info">
    <div
      v-for="(sdkValue, sdkName) in preCheckoutData"
      :key="sdkName"
    >
      <h4>
        {{ sdkName.toUpperCase() }}
      </h4>
      <p>
        <span>{{ sdkCapitalizeNames[sdkName] }}-{{ $t('label.srcInitiatorId') }} :</span>
        <span>{{ sdkValue.srcInitiatorId }}</span>
      </p>
      <p>
        <span>{{ sdkCapitalizeNames[sdkName] }}-{{ $t('label.srciDpaId') }} :</span>
        <span>{{ sdkValue.srciDpaId }}</span>
      </p>
    </div>
  </div>
</template>
